import api from './api';

/**
 * Fetch all logistics information with optional filters
 * @param {Object} params - Query parameters
 * @returns {Promise} Logistics data
 */
export const fetchLogistics = async (params = {}) => {
  const queryParams = new URLSearchParams();
  
  if (params.page) queryParams.append('page', params.page);
  if (params.page_size) queryParams.append('page_size', params.page_size);
  if (params.method) queryParams.append('method', params.method);
  if (params.terminal_port) queryParams.append('terminal_port', params.terminal_port);
  if (params.shipping_agent) queryParams.append('shipping_agent', params.shipping_agent);
  if (params.goods_type) queryParams.append('goods_type', params.goods_type);
  if (params.search) queryParams.append('search', params.search);
  
  const res = await api.get(`/admin/logistics/?${queryParams.toString()}`);
  return res.data;
};

export const fetchLogisticsInfo = async (params = {}) => {
  const queryParams = new URLSearchParams();

  if (params.page) queryParams.append('page', params.page);
  if (params.page_size) queryParams.append('page_size', params.page_size);
  if (params.method) queryParams.append('method', params.method);
  if (params.package_type) queryParams.append('package_type', params.package_type);

  const queryString = queryParams.toString();
  const res = await api.get(`/app/logistics/${queryString ? `?${queryString}` : ''}`);
  return res.data;
};

/**
 * Create new logistics information
 * @param {Object} data - Logistics data
 * @returns {Promise} Created logistics data
 */
export const createLogistics = async (data) => {
  const res = await api.post('/admin/logistics/', data);
  return res.data;
};

/**
 * Update logistics information
 * @param {number} id - Logistics ID
 * @param {Object} data - Updated data
 * @returns {Promise} Updated logistics data
 */
export const updateLogistics = async (id, data) => {
  const res = await api.patch(`/admin/logistics/${id}/`, data);
  return res.data;
};

/**
 * Delete logistics information
 * @param {number} id - Logistics ID
 * @returns {Promise} Response
 */
export const deleteLogistics = async (id) => {
  const res = await api.delete(`/admin/logistics/${id}/`);
  return res.data;
};

const logisticsService = {
  fetchLogistics,
  fetchLogisticsInfo,
  createLogistics,
  updateLogistics,
  deleteLogistics
};

export default logisticsService;


